<template>
  <div v-show="isSectionManager">
    <!-- Status Button (Check Device Status / Loading / Error) -->
    <button
      v-show="!isDeviceOperable || isDeviceOperable == null"
      class="status-button row"
      :class="{
        loading: getIsLoading,
        error: getHasError
      }"
      :disabled="getIsLoading || getHasError"
    >
      <span v-if="getIsLoading">
        <i class="fa fa-spinner fa-spin" style="font-size: 2rem"></i> Checking...
      </span>
      <span v-else-if="getHasError">⚠️ Not Operable</span>
      <span v-else>🖥️ Check Device Status</span>
    </button>

    <!-- Single Power Button (Up / Down) -->
    <button
      @click="powerSystem"
      v-show="isDeviceOperable"
      :class="['power-button row', isDeviceOn ? 'power-down' : 'power-up']"
    >
      <i
        class="fa power-icon"
        :class="isPowering ? 'fa-spinner fa-spin' : 'fa-power-off'"
      ></i>
      {{ isDeviceOn ? 'Power Down' : 'Power Up' }}
    </button>
  </div>
</template>

<script>
import Noty from "noty";

export default {
  name: "PowerBtn",
  data() {
    return {
      isSectionManager: false,
      isLoading: false,
      hasError: false,
      isDeviceOperable: null,
      isDeviceShutdown: null,
      inverterId: null,
      isPowering: false,
    };
  },
  computed: {
    getIsLoading() {
      return this.isLoading;
    },
    getHasError() {
      return this.hasError;
    },
    isDeviceOn() {
      return !this.isDeviceShutdown;
    }
  },
  methods: {
    getPartnerAccessStatus() {
      this.isLoading = true;
      this.hasError = false;
      const PartnerHTTP = this.$httpUtils.PartnerHTTP;
      const partnerId = localStorage.getItem("uuid");
      const headers = {
        "Content-Type": "application/json",
        "x-user-role": localStorage.getItem("roleType")
      };

      return PartnerHTTP.get(`/partners/${partnerId}/access-status`, { headers })
        .then(res => {
          localStorage.setItem("partnerAPIKey", res.data.api_access.api_key);
          this.getInverterStatus();
          return res;
        })
        .catch(err => {
          this.hasError = true;
          this.isLoading = false;
          return false;
        });
    },

    getInverterStatus() {
      const PARTNERHTTP = this.$httpUtils.PartnerHTTP;
      this.isLoading = true;
      this.isPowering = true;
      this.hasError = false;
      const { deviceId } = this.$route.params;
      this.inverterId = deviceId;
      const deviceStatusURL = `/ext/device-power-status/deviceIds?device_ids=${this.inverterId}`;

      return PARTNERHTTP.get(deviceStatusURL)
        .then(res => {
          let deviceStatus = res.data[0][Number(deviceId)] || "NOT DETECTED";
          deviceStatus = deviceStatus.toString();

          if (deviceStatus !== "NOT DETECTED") {
            this.isDeviceOperable = true;
            this.hasError = false;
            this.isDeviceShutdown = deviceStatus !== "ON";
          } else {
            this.isDeviceOperable = false;
            this.hasError = true;
          }
          return res.data;
        })
        .catch(err => {
          if (err.response && err.response.status == 409) {
            this.isDeviceOperable = null;
            this.isDeviceShutdown = null;
            this.getInverterStatus();
          }

          if (err.response && err.response.status == 401) {
            this.isDeviceOperable = false;
            this.hasError = true;
            this.showToast(err.response.data.detail, "error");
          }
          return false;
        })
        .finally(() => {
          this.isLoading = false;
          this.isPowering = false;
        });
    },

    powerSystem() {
      this.hasError = false;
      this.isPowering = true;
      const PARTNERHTTP = this.$httpUtils.PartnerHTTP;
      const powerURL = `/ext/power-device/${this.inverterId}`;
      const payload = {
        changeState: this.isDeviceShutdown ? "power_on" : "power_off"
      };

      return PARTNERHTTP.post(powerURL, payload)
        .then(res => {
          this.showToast(res.data.message, "success");
          this.getInverterStatus();
          return res.data;
        })
        .catch(err => {
          this.hasError = true;
          return false;
        });
    },

    showToast(text, type = "success") {
      new Noty({
        theme: "bootstrap-v3",
        text,
        type,
        timeout: 1000
      }).show();
    }
  },
  mounted() {
    const roleType = localStorage.getItem("roleType");
    this.isSectionManager = roleType === "section manager";
    if (!this.isSectionManager) return;
    this.getPartnerAccessStatus();
    // this.getClientDeviceStatus();
  }
};
</script>

<style scoped>
.power-button {
  padding: 12px;
  width: max-content;
  margin: 0 5px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  margin-bottom: 0 !important;
}

.power-down {
  background-color: #ff0000;
  box-shadow: 0 4px 10px rgba(255, 0, 0, 0.3);
}

.power-down:hover {
  background-color: #cc0000;
  box-shadow: 0 6px 14px rgba(255, 0, 0, 0.5);
  transform: translateY(-2px);
}

.power-down:active {
  background-color: #990000;
  transform: scale(0.98);
}

.power-up {
  background-color: #00c851;
  box-shadow: 0 4px 10px rgba(0, 200, 81, 0.3);
}

.power-up:hover {
  background-color: #009933;
  box-shadow: 0 6px 14px rgba(0, 200, 81, 0.5);
  transform: translateY(-2px);
}

.power-up:active {
  background-color: #006622;
  transform: scale(0.98);
}

.power-button:disabled {
  background-color: #ccc;
  color: #666;
  cursor: not-allowed;
  box-shadow: none;
}

.power-icon {
  margin-right: 8px;
  font-size: 20px;
  width: min-content;
}

.status-button {
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
  background-color: #2196f3;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
  margin-right: 12px;
}

.status-button.loading {
  background-color: #1976d2;
  cursor: wait;
}

.status-button.error {
  background-color: #f44336;
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.4);
  cursor: not-allowed;
}

.status-button:disabled {
  opacity: 0.7;
}

.row {
  display: flex;
  flex-direction: row;
  width: max-content;
  margin: 0 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/performance/components/PowerBtn.vue